import type { Scale2d } from "@logic/lib/2d"
import type { Panel } from "@logic/lib/design"

import type { TransactionOperation } from "."
import { getPanelScale } from "./getPanelScale"
import { panelGapState } from "../panels"

export const getPanelFootprint: TransactionOperation<Panel | null, Scale2d> = (
  transactors,
  panel = null,
) => {
  const gap = transactors.get(panelGapState)
  const { h, w } = getPanelScale(
    transactors,
    panel
      ? {
          ...panel,
          gap: gap,
        }
      : null,
  )

  return {
    h: h,
    w: w,
  }
}
